import { type PropsWithChildren, forwardRef } from "react";

import type { CheckboxProps } from "./Checkbox.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const Checkbox = forwardRef<HTMLInputElement, PropsWithChildren<CheckboxProps>>(
  (
    { checkboxSize = "small", className, onChange, ...checkboxProps },
    forwardedRef,
  ) => {
    return (
      <input
        ref={forwardedRef}
        type="checkbox"
        className={cn(
          "checkbox rounded border-primary bg-white text-primary transition duration-200 checked:border-primary checked:bg-white checked:text-primary checked:hover:border-primary checked:hover:bg-white focus:outline focus:outline-1 focus:ring-0 focus:ring-offset-0 checked:focus:border-primary checked:focus:bg-white disabled:pointer-events-none disabled:opacity-50",
          {
            "h-4 w-4": checkboxSize === "small",
            "h-5 w-5": checkboxSize === "medium",
          },
          className,
        )}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={(event) => {
          if (onChange) onChange(event.currentTarget.checked);
        }}
        {...checkboxProps}
      />
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
